// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module--wrapper--3ZtBh","icon":"style-module--icon--tHTL5","dash":"style-module--dash--UEh9X"};